import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
  style?: object;
};
function UploadMedium({
  size = 16,
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 24 24" fill={color} style={style}><path fillRule="evenodd" clipRule="evenodd" d="M12 2.1a.9.9 0 01.636.264l5 5a.9.9 0 11-1.273 1.273L12.9 5.172v11.829a.9.9 0 01-1.8 0V5.174L7.635 8.637a.9.9 0 01-1.272-1.272l5-5.001A.9.9 0 0112 2.1zm-9 14a.9.9 0 01.9.9A3.1 3.1 0 007 20.1h10a3.1 3.1 0 003.1-3.1.9.9 0 111.8 0 4.9 4.9 0 01-4.9 4.9H7A4.9 4.9 0 012.1 17a.9.9 0 01.9-.9z"  /></Svg>;
}
export default UploadMedium;